import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["flash"]
  static values  = { text: String }

  async copy(event) {
    event?.preventDefault()
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.flashTarget.classList.add("is-visible")
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.flashTarget.classList.remove("is-visible"), 1800)
    } catch (_e) {}
  }
}
